import { LoadingIcon } from '@weblite/icons'
import styled from '@emotion/styled'

export const CssCircularLoading = styled(LoadingIcon)`
  @keyframes rotate {
    from {
      transform: rotate(-360deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  width: 20px;
  height: 20px;
  color: white;
  animation-name: rotate;
  animation-duration: 5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  border-radius: 50%;
`
